import { render, staticRenderFns } from "./remaining_budgets.vue?vue&type=template&id=f1847774&"
import script from "./remaining_budgets.vue?vue&type=script&lang=js&"
export * from "./remaining_budgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports